import React, { useEffect, useState } from 'react'
import classnames from 'classnames'
import Overlay from './styles/Overlay'
import SliderModal from './styles/SliderModal'
import { DolaThemes } from '../../styles/types'
import ClassicModal from './styles/ClassicModal'
import StyledModal from './styles/Modal'

interface ModalProps {
  open: boolean
  handleClose: () => void
  sideBarClassName?: string
  theme?: DolaThemes
  type?: 'slider' | 'classic'
}

const Modal: React.FC<ModalProps> = ({
  children,
  open: suppliedActiveState,
  handleClose,
  sideBarClassName = '',
  theme = 'light',
  type = 'slider',
}) => {
  const [open, setOpen] = useState(suppliedActiveState)
  const [closing, setClosing] = useState(false)

  useEffect(() => {
    if (suppliedActiveState && !open) {
      setOpen(true)
    } else if (!suppliedActiveState && open) {
      setClosing(true)

      setTimeout(() => {
        setClosing(false)
        setOpen(false)
      }, 400)
    }
  }, [suppliedActiveState])

  return (
    <StyledModal dolaTheme={theme}>
      <Overlay
        dolaTheme={theme}
        visible={open}
        closing={closing}
        onClick={handleClose}
      />
      {type === 'slider' && (
        <SliderModal
          dolaTheme={theme}
          visible={suppliedActiveState}
          className={classnames('slider-modal', {
            'slider-modal--visible': suppliedActiveState,
            [sideBarClassName]: !!sideBarClassName,
          })}
        >
          {children}
        </SliderModal>
      )}
      {type === 'classic' && (
        <ClassicModal
          closing={closing}
          dolaTheme={theme}
          visible={suppliedActiveState}
        >
          {children}
        </ClassicModal>
      )}
    </StyledModal>
  )
}

export default Modal
